module.exports = __webpack_public_path__ + "static/img/Bachelor_010289.1a49ddd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010289.jpg
// module id = 140
// module chunks = 0